import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import Input from "../Input"
import ThemeConsumer from "../ThemeConsumer"

const FloatLabelInput = ({
  theme,
  disabled,
  id,
  type,
  error,
  value,
  onChange,
  label,
  containerClasses,
  renderIcon,
  positionIcon,
  icons,
  iconName,
  classNames,
  margin,
  placeholder,
  ...props
}) => {
  const marginClass = theme[`margin_${margin}`]
  const containerInput = classnames(
    containerClasses,
    theme.floatLabel,
    marginClass,
    {
      [theme.invalid]: error,
      [theme.disabled]: disabled,
      [theme.hasPlaceholder]: placeholder !== ""
    }
  )

  const IconComponent = icons[iconName] || null

  return (
    <div className={containerInput}>
      {IconComponent && <IconComponent />}
      <Input
        {...props}
        disabled={disabled}
        id={id}
        type={type}
        onChange={onChange}
        value={value}
        classNames={classNames}
        icons={iconName}
        placeholder={placeholder}
      />
      {label && (
        <label htmlFor={id} className={theme.label}>
          {label}
        </label>
      )}
      <Icon renderIcon={renderIcon} positionIcon={positionIcon} theme={theme} />
      {error && <span className={theme.error}>{error}</span>}
    </div>
  )
}

const Icon = ({ renderIcon, theme, positionIcon }) => {
  if (!renderIcon) return null

  const iconClasses = classnames({
    [theme.right]: positionIcon === "right"
  })

  return <div className={iconClasses}>{renderIcon()}</div>
}

Icon.propTypes = {
  renderIcon: PropTypes.func,
  theme: PropTypes.shape({
    right: PropTypes.string
  }),
  positionIcon: PropTypes.string
}

FloatLabelInput.propTypes = {
  theme: PropTypes.shape({
    floatLabel: PropTypes.string,
    invalid: PropTypes.string,
    disabled: PropTypes.string,
    error: PropTypes.string,
    hasValue: PropTypes.string,
    label: PropTypes.string,
    hasPlaceholder: PropTypes.string
  }),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string,
  containerClasses: PropTypes.string,
  renderIcon: PropTypes.string,
  positionIcon: PropTypes.string,
  icons: PropTypes.object.isRequired,
  iconName: PropTypes.string,
  placeholder: PropTypes.string,
  classNames: PropTypes.string,
  margin: PropTypes.string
}

FloatLabelInput.defaultProps = {
  error: "",
  type: "text",
  disabled: false,
  value: "",
  placeholder: ""
}

export default ThemeConsumer("UIModernFloatLabel")(FloatLabelInput)



// WEBPACK FOOTER //
// ./src/shared/components/ModernFloatLabelInput/index.js